export const adminColumnFields = ['name'] as const;

export const columnFields = ['name'] as const;
